import React from "react";
import { connect } from "react-redux";

import { auth } from "../../../firebase";
import * as actions from "../../../store/actions";

import classes from "./VerifyEmailPurchase.module.css";

const VerifyEmailPurchase = ({ email, category, onUpdatePurchased }) => {
  const logout = () => {
    auth.signOut();
    onUpdatePurchased([]);
  };

  return (
    <div className={classes.VerifyEmailPurchase}>
      <h2>Activate your account</h2>
      <p>
        Please activate your account before making a purchase. We've sent you an
        email to the <strong>{email}</strong> email address. Follow the
        instructions in that email to activate your account. After you're done
        with that, hit the refresh button to be allowed to purchase the{" "}
        <strong>{category.name}</strong> premium category.
      </p>
      <button onClick={() => window.location.reload()}>Refresh</button>
      <button onClick={logout} className={classes.Link}>
        Log into another account?
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  email: state.email,
});

const mapDispatchToProps = (dispatch) => ({
  onUpdatePurchased: (purchased) =>
    dispatch(actions.updatePurchased(purchased)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyEmailPurchase);
